<div class="ingredient-wrapper" [ngClass]="{'grouped': pluralQuals}" *ngIf="!isHalfAndHalf || (isHalfAndHalf && !hideInHalfAndHalf)">
  <button *ngIf="groupedQualifiers?.length === 1 && groupedQualifiers[0].length === 1" class="btn font-primary fw-300 single-qualifier-btn" (click)='toggleSingleQualifier(groupedQualifiers)'>
    <span
    [ngClass]="(orderedQualifiers | some : groupedQualifiers[0][0].name) ? 'selection-text-color fw-600 ingredient-selected-qualifier' : 'primary-text-color'">
      {{groupedQualifiers[0][0].name}}
    </span>
  </button>
  <div *ngIf="pluralQuals" class="primary-bg-color qualifiers" tabindex="0"
       [ftsCustomPopover]="popTemplateRef"
       [popoverContextEl]="popoverContextEl"
       [popoverManualOffset]="110"
       [isSecondHalf]="isSecondHalf"
       [config]="{viewportTopOffset: viewportTopOffset,
                  viewportHeight: viewportHeight,
                  arrowPosition: popoverArrowPosition,
                  containerPosition: popoverContainerPosition,
                  ariaLabel: ('component.item_editor.choice.qualifier_choice.extra' | translate)}">
    <div [@scaleX]="visible" class='text-center selected-qualifier'>
      <ng-container *ngIf='orderedQualifiers'>
        <span *ngFor='let qualifier of orderedQualifiers' class='fw-600 ingredient-selected-qualifier'>
          {{qualifier}}
        </span>
      </ng-container>
      <span *ngIf="!orderedQualifiers?.length" class="fit-qualifier-arrow" translate>
        <ng-container *ngIf="isSecondHalf">{{'component.item_editor.choice.qualifier_choice.none'}} <fa-icon [icon]='faCaretDown'></fa-icon></ng-container>
        <ng-container *ngIf="!isSecondHalf">
          {{sideOnly ? 'component.item_editor.choice.qualifier_choice.side' : 'component.item_editor.choice.qualifier_choice.extra'}}
        </ng-container>
      </span>
    </div>
  </div>
</div>

<div #popTemplate class="popover-template">
  <div class="buttons-wrapper primary-bg-color text-right" [ngClass]="{'width-fit-content': isMobile}">
    <div class="btn-group qualifier-btn-group" *ngFor="let group of groupedQualifiers; trackBy: trackByQualifierTypeFn;">
      <button class='btn btn-success selection-border-color ingredient-qualifier-btn font-secondary'
              *ngFor="let qualifier of group"
              [ngClass]="(orderedQualifiers | some : qualifier.name) ? 'selection-bg-color selection-inverse-text-color' : 'primary-bg-color primary-text-color'"
              [attr.aria-pressed]="orderedQualifiers | some : qualifier.name"
              (click)='toggleQualifier(qualifier)'>
        <span class='show'>{{qualifier.name}}</span>
        <span class='fw-300' *ngIf="(qualifier | qualifierCalories : size : isHalf) as cals">&nbsp;{{cals}} {{'component.item_editor.choice.qualifier_choice.cal' | translate}}</span>
      </button>
    </div>
  </div>
</div>
